import { misionData, visionData } from '@/mocks/nosotros-data';

export default function MisionVision() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            {/* Misión */}
            <article className="group relative rounded-2xl bg-background-50 border border-secondary-200/60 p-8 md:p-10 lg:p-12 hover:border-primary-200/60 transition-all duration-500">
              <div className="absolute top-0 right-0 w-32 h-32 bg-primary-50/50 rounded-bl-full opacity-50 group-hover:opacity-80 transition-opacity duration-500" />
              <div className="relative z-10">
                <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary-100 text-primary-600 mb-5">
                  <i className="ri-focus-3-line text-lg" />
                </span>
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
                  {misionData.title}
                </h3>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {misionData.description}
                </p>
              </div>
            </article>

            {/* Visión */}
            <article className="group relative rounded-2xl bg-background-50 border border-secondary-200/60 p-8 md:p-10 lg:p-12 hover:border-primary-200/60 transition-all duration-500">
              <div className="absolute top-0 right-0 w-32 h-32 bg-accent-50/50 rounded-bl-full opacity-50 group-hover:opacity-80 transition-opacity duration-500" />
              <div className="relative z-10">
                <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent-100 text-accent-600 mb-5">
                  <i className="ri-eye-line text-lg" />
                </span>
                <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
                  {visionData.title}
                </h3>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {visionData.description}
                </p>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}